import { useSelector } from 'react-redux';

interface SortValue {
  name: string;
  value: string;
}

interface ProjectData {
  sorting: SortValue[];
}

interface Project {
  data: ProjectData;
}

interface AppContext {
  project: Project;
}

interface RootState {
  app: {
    context: AppContext;
  };
}

interface UseSortByReturn {
  sortValues: SortValue[];
}

export const useSortBy = (): UseSortByReturn => {
  const {
    project: {
      data: { sorting },
    },
  } = useSelector((state: RootState) => state.app.context);

  return {
    sortValues: sorting,
  };
};
